// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"81775deb","592":"38c92433"}[chunkId] + ".chunk.js";
};